import { createSlice } from '@reduxjs/toolkit'

const globalSlice = createSlice({
  name: 'global',
  initialState: {
    authData: { isAuthorized: false, isTwoFactorAuthenticated: false, obfuscationToken: null },
    configData: {},
    isLoading: true,
    locale: 'es-ES',
  },
  reducers: {
    setAuthData: (state, { payload }) => {
      state.authData = payload
      state.isLoading = false
    },
    setConfigData: (state, { payload }) => {
      state.configData = payload
    },
    setGlobalLoading: (state, { payload }) => {
      state.isLoading = payload
    },
    setLocale: (state, { payload }) => {
      state.locale = payload
    },
    setTwoFactorAuthentication: (state, { payload }) => {
      state.authData.isTwoFactorAuthenticated = payload // Actualizar 2FA
    },
    setObfuscationToken: (state, { payload }) => {
      state.authData.obfuscationToken = payload
      state.authData.isTwoFactorAuthenticated = !!payload?.token
    },
  },
})

export const globalReducer = globalSlice.reducer

export const {
  setAuthData,
  setConfigData,
  setGlobalLoading,
  setLocale,
  setTwoFactorAuthentication,
  setObfuscationToken,
} = globalSlice.actions
